import { $Q } from './querySelector';

(() => {
  document.addEventListener('click', (event) => {
    const elementToCheck = document.querySelector(
      '.user-nav__list .tl-dropdown'
    );

    if (
      elementToCheck &&
      !elementToCheck.contains(event.target) &&
      elementToCheck.classList.contains('active')
    ) {
      elementToCheck.classList.remove('active');
      elementToCheck.classList.add('closed');
      elementToCheck.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const weglotItem = $Q('.user-nav .custom-weglot');
    weglotItem.addEventListener('mouseleave', () => {
      const elementToCheck = document.querySelector(
        '.user-nav__list .tl-dropdown'
      );

      elementToCheck.classList.remove('active');
      elementToCheck.classList.add('closed');
      elementToCheck.setAttribute('aria-expanded', 'false');
    });

    weglotItem.addEventListener('mouseenter', () => {
      const elementToCheck = document.querySelector(
        '.user-nav__list .tl-dropdown'
      );

      elementToCheck.classList.remove('closed');
      elementToCheck.classList.add('active');
      elementToCheck.setAttribute('aria-expanded', 'false');
    });
  });

  const tlSwitcher = document.querySelectorAll('.tl-selections');

  tlSwitcher.forEach((element) => {
    if (element) {
      const arrow = document.createElement('div');
      arrow.classList.add('tl-selection');
      arrow.innerHTML =
        '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6" width="14"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg>';
      element.appendChild(arrow);
    }
  });
})();
